import { FC, useMemo, useState } from 'react'
import { QueueMode } from '../../QueueNew'
import {
    QueueBottomDescriptionWrapper,
    QueueBottomRight,
    QueueBottomWrapper,
    QueueTitle,
    QueueTopWrapper
} from '../../styles'
import QueueLineNew from '../QueueLineNew'
import { QueueRate } from '../QueueLineNew/QueueLineNew'
import { QueueBottomLabel, QueuePriceInputWrapper, QueueRateChooser, QueueRateItem, QueueUploadPrice, QueueUploadPriceWrapper, TitleHint } from './styles'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FlexBox, MagicBox, useBreakpoint } from '@brg/ui'
import { tariffColors } from '../../const'
import {FlorinIcon} from "../../../../../../../icons/FlorinIcon/FlorinIcon";
import {useTariffs} from "../../../helpers/queueHooks";
import {AvailableTariff, TariffTypes} from "../../../../../constants/types";
import {selectorOrder} from "../../../../../slices/OrderSlice";
import {LayoutConst} from "../../../../../../../../core";

interface QueueCreateProps {
    isBook?: boolean
    cardsLength?: number
}

export const QueueCreate: FC<QueueCreateProps> = (props) => {
    const { isBook, cardsLength } = props
    const { t } = useTranslation()
    const [rate, setRate] = useState<QueueRate>(QueueRate.low)
    const is744BP = useBreakpoint(LayoutConst.screen.s);
    const is992BP = useBreakpoint(LayoutConst.screen.m);
    const is568BP = useBreakpoint(LayoutConst.screen.sm);
    const { availableTariffs, tariffsLoading, activeTariff, error: orderError } = useSelector(selectorOrder)
    const posMap = useMemo(() => [0, 1], [])
    const { changePrice, onChangeTariff, onPay} = useTariffs({})

    const BottomLineQueue = useMemo(() => {
        if (is568BP) {
            return <FlexBox width="100%" direction="column" directionMobile="column">
            <QueueBottomWrapper>
                <FlexBox width="100%" justify="space-between">
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>{t('tariffs.cards_in_book')}</QueueBottomLabel>
                        <QueueUploadPrice nonMinWidth>{cardsLength}</QueueUploadPrice>
                    </QueuePriceInputWrapper>
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>Цена книги</QueueBottomLabel>
                        <QueueUploadPrice nonMinWidth>
                            {activeTariff?.userPrice || '0'}  <FlorinIcon size={24 / 16} mobileSize={24 / 16} />
                        </QueueUploadPrice>
                    </QueuePriceInputWrapper>
                </FlexBox>
                <FlexBox width="100%" justify="space-between" offsetTop={16}>
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>{t('tariffs.upload_fee')}</QueueBottomLabel>
                        <QueueUploadPrice nonMinWidth>
                            {activeTariff?.creatingPrice || '0'}  <FlorinIcon size={24 / 16} mobileSize={24 / 16} />
                        </QueueUploadPrice>
                    </QueuePriceInputWrapper>
                </FlexBox>
            </QueueBottomWrapper>
            <QueueBottomDescriptionWrapper>
                <span>Цена книги зависит от количества карточек.</span>
                {is568BP && <div id='publish-button-container' />}
            </QueueBottomDescriptionWrapper>
            {!is568BP && <div id='publish-button-container' />}

        </FlexBox>
        }

        return <FlexBox width="100%" direction="column" directionMobile="column">
            <QueueBottomWrapper>
                <FlexBox gx={40}>
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>{t('tariffs.cards_in_book')}</QueueBottomLabel>
                        <QueueUploadPrice nonMinWidth>{cardsLength}</QueueUploadPrice>
                    </QueuePriceInputWrapper>
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>Цена книги</QueueBottomLabel>
                        <QueueUploadPrice>
                            {activeTariff?.userPrice || '0'}  <FlorinIcon size={24 / 16} mobileSize={24 / 16} />
                        </QueueUploadPrice>
                    </QueuePriceInputWrapper>
                </FlexBox>
                <QueueBottomRight>
                    <QueueUploadPriceWrapper>
                        <QueueBottomLabel>{t('tariffs.upload_fee')}</QueueBottomLabel>
                        <QueueUploadPrice>
                            {activeTariff?.creatingPrice || '0'}  <FlorinIcon size={24 / 16} mobileSize={24 / 16} />
                        </QueueUploadPrice>
                    </QueueUploadPriceWrapper>
                </QueueBottomRight>
            </QueueBottomWrapper>
            <QueueBottomDescriptionWrapper>
                Цена книги зависит от количества карточек.
                <div id='publish-button-container' />
            </QueueBottomDescriptionWrapper>
        </FlexBox>
    }, [is744BP, cardsLength, activeTariff, is992BP, is568BP, t])

    return <>
        <QueueTopWrapper mode={QueueMode.create}>
            <MagicBox justify='space-between' align='center' width='calc(100% - 48px)'>
                <QueueTitle
                    align='center'
                    alignMobile='center'
                    justify='space-between'
                    justifyMobile='space-between'
                >
                    {t('tariffs.tariff_setting')}
                </QueueTitle>
                {!isBook && <TitleHint justify='center' align='center' title={t('tariffs.tariff_setting')}>?</TitleHint>}
            </MagicBox>
            <QueueRateChooser>
                {
                    !!availableTariffs?.length && availableTariffs.map((tariffItem: AvailableTariff, idx: number) => {
                        const isSelected = (tariffItem?.type === activeTariff?.type) || 
                            ((tariffItem?.type === TariffTypes.high) && (activeTariff?.type === TariffTypes.custom))
                        const tariffColor = isSelected ? tariffColors[idx] || tariffColors[0] : tariffColors[0]
                        return <QueueRateItem
                            align='center'
                            alignMobile='center'
                            bgColor={tariffColor}
                            justify='center'
                            justifyMobile='center'
                            key={idx}
                            onClick={onChangeTariff(tariffItem)}
                            selected={isSelected}
                            title={t('tariffs.author_royal_title')}
                        >
                            {
                                tariffItem?.authorK !== undefined
                                    ? tariffItem?.authorK * 100 + '%'
                                    : ''
                            }
                        </QueueRateItem>
                    })

                }
            </QueueRateChooser>
        </QueueTopWrapper>
        <QueueLineNew
            rate={rate}
            circlePoses={posMap}
            circlePosesMob={posMap}
            mode={QueueMode.create}
            isBook={false}
        />
        {BottomLineQueue}
    </>
}import { FC, useMemo, useState } from 'react'
import { QueueMode } from '../../QueueNew'
import {
    QueueBottomDescriptionWrapper,
    QueueBottomRight,
    QueueBottomWrapper,
    QueueTitle,
    QueueTopWrapper
} from '../../styles'
import QueueLineNew from '../QueueLineNew'
import { QueueRate } from '../QueueLineNew/QueueLineNew'
import { QueueBottomLabel, QueuePriceInputWrapper, QueueRateChooser, QueueRateItem, QueueUploadPrice, QueueUploadPriceWrapper, TitleHint } from './styles'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FlexBox, MagicBox, useBreakpoint } from '@brg/ui'
import { tariffColors } from '../../const'
import {FlorinIcon} from "../../../../../../../icons/FlorinIcon/FlorinIcon";
import {useTariffs} from "../../../helpers/queueHooks";
import {AvailableTariff, TariffTypes} from "../../../../../constants/types";
import {selectorOrder} from "../../../../../slices/OrderSlice";
import {LayoutConst} from "../../../../../../../../core";

interface QueueCreateProps {
    isBook?: boolean
    cardsLength?: number
}

export const QueueCreate: FC<QueueCreateProps> = (props) => {
    const { isBook, cardsLength } = props
    const { t } = useTranslation()
    const [rate, setRate] = useState<QueueRate>(QueueRate.low)
    const is744BP = useBreakpoint(LayoutConst.screen.s);
    const is992BP = useBreakpoint(LayoutConst.screen.m);
    const is568BP = useBreakpoint(LayoutConst.screen.sm);
    const { availableTariffs, tariffsLoading, activeTariff, error: orderError } = useSelector(selectorOrder)
    const posMap = useMemo(() => [0, 1], [])
    const { changePrice, onChangeTariff, onPay} = useTariffs({})

    const BottomLineQueue = useMemo(() => {
        if (is568BP) {
            return <FlexBox width="100%" direction="column" directionMobile="column">
            <QueueBottomWrapper>
                <FlexBox width="100%" justify="space-between">
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>{t('tariffs.cards_in_book')}</QueueBottomLabel>
                        <QueueUploadPrice nonMinWidth>{cardsLength}</QueueUploadPrice>
                    </QueuePriceInputWrapper>
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>Цена книги</QueueBottomLabel>
                        <QueueUploadPrice nonMinWidth>
                            {activeTariff?.userPrice || '0'}  <FlorinIcon size={24 / 16} mobileSize={24 / 16} />
                        </QueueUploadPrice>
                    </QueuePriceInputWrapper>
                </FlexBox>
                <FlexBox width="100%" justify="space-between" offsetTop={16}>
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>{t('tariffs.upload_fee')}</QueueBottomLabel>
                        <QueueUploadPrice nonMinWidth>
                            {activeTariff?.creatingPrice || '0'}  <FlorinIcon size={24 / 16} mobileSize={24 / 16} />
                        </QueueUploadPrice>
                    </QueuePriceInputWrapper>
                </FlexBox>
            </QueueBottomWrapper>
            <QueueBottomDescriptionWrapper>
                <span>Цена книги зависит от количества карточек.</span>
                {is568BP && <div id='publish-button-container' />}
            </QueueBottomDescriptionWrapper>
            {!is568BP && <div id='publish-button-container' />}

        </FlexBox>
        }

        return <FlexBox width="100%" direction="column" directionMobile="column">
            <QueueBottomWrapper>
                <FlexBox gx={40}>
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>{t('tariffs.cards_in_book')}</QueueBottomLabel>
                        <QueueUploadPrice nonMinWidth>{cardsLength}</QueueUploadPrice>
                    </QueuePriceInputWrapper>
                    <QueuePriceInputWrapper>
                        <QueueBottomLabel>Цена книги</QueueBottomLabel>
                        <QueueUploadPrice>
                            {activeTariff?.userPrice || '0'}  <FlorinIcon size={24 / 16} mobileSize={24 / 16} />
                        </QueueUploadPrice>
                    </QueuePriceInputWrapper>
                </FlexBox>
                <QueueBottomRight>
                    <QueueUploadPriceWrapper>
                        <QueueBottomLabel>{t('tariffs.upload_fee')}</QueueBottomLabel>
                        <QueueUploadPrice>
                            {activeTariff?.creatingPrice || '0'}  <FlorinIcon size={24 / 16} mobileSize={24 / 16} />
                        </QueueUploadPrice>
                    </QueueUploadPriceWrapper>
                </QueueBottomRight>
            </QueueBottomWrapper>
            <QueueBottomDescriptionWrapper>
                Цена книги зависит от количества карточек.
                <div id='publish-button-container' />
            </QueueBottomDescriptionWrapper>
        </FlexBox>
    }, [is744BP, cardsLength, activeTariff, is992BP, is568BP, t])

    return <>
        <QueueTopWrapper mode={QueueMode.create}>
            <MagicBox justify='space-between' align='center' width='calc(100% - 48px)'>
                <QueueTitle
                    align='center'
                    alignMobile='center'
                    justify='space-between'
                    justifyMobile='space-between'
                >
                    {t('tariffs.tariff_setting')}
                </QueueTitle>
                {!isBook && <TitleHint justify='center' align='center' title={t('tariffs.tariff_setting')}>?</TitleHint>}
            </MagicBox>
            <QueueRateChooser>
                {
                    !!availableTariffs?.length && availableTariffs.map((tariffItem: AvailableTariff, idx: number) => {
                        const isSelected = (tariffItem?.type === activeTariff?.type) || 
                            ((tariffItem?.type === TariffTypes.high) && (activeTariff?.type === TariffTypes.custom))
                        const tariffColor = isSelected ? tariffColors[idx] || tariffColors[0] : tariffColors[0]
                        return <QueueRateItem
                            align='center'
                            alignMobile='center'
                            bgColor={tariffColor}
                            justify='center'
                            justifyMobile='center'
                            key={idx}
                            onClick={onChangeTariff(tariffItem)}
                            selected={isSelected}
                            title={t('tariffs.author_royal_title')}
                        >
                            {
                                tariffItem?.authorK !== undefined
                                    ? tariffItem?.authorK * 100 + '%'
                                    : ''
                            }
                        </QueueRateItem>
                    })

                }
            </QueueRateChooser>
        </QueueTopWrapper>
        <QueueLineNew
            rate={rate}
            circlePoses={posMap}
            circlePosesMob={posMap}
            mode={QueueMode.create}
            isBook={false}
        />
        {BottomLineQueue}
    </>
}